import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/companyPolicy`;

export const ROUTE: RouteDefinition = `${baseRoute}/companyPolicy`;

export const URL = (): RouteDefinition => `${baseRoute}/companyPolicy`;
